import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { FormBuilder, FormGroup } from "@angular/forms";
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import * as moment from 'moment';
import 'moment-timezone';
import { NgxSpinnerService } from "ngx-spinner";
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';

import { LoginService } from '../services/login.service';
import { DashboardService } from '../services/dashboard.service';

@Component({
    selector: 'app-pdfreport',
    templateUrl: './pdfreport.component.html',
    styleUrls: ['./pdfreport.component.css']
})
export class PdfreportComponent implements OnInit {
    @ViewChild('download_area', { static: false }) download_area: ElementRef;
    public project_id: any = {};
    public project = '';
    public session_data: any = {};
    public err: any = {};
    public form: any = {};
    public result: any = {};
    public sentiment = 0;
    public country = '';
    public text_search = '';
    public checked_sm: any = { all: true, twitter: false, facebook: false, instagram: false, web: false, youtube: false, reviews: false, others: false };
    public data_range: any = {};
    public countries: any = {};
    public total_per_sm: any = {};
    public latest_mentions = [];
    public popular_mentions = [];
    public top_profiles = [];
    public quotes = [];
    public canvas_chart = '';

    public response: any = { download: true, project: false, summary: false, graph: false, catrgory: false, latest: false, popular: false };
    public can_generate: any = {};
    public summary: any = {};

    no_of_requests: number = 0;
    no_of_responses: number = 0;
    p: number = 1;
    total: number = 80;
    page_length: number = 20;

    public lineChartData = [];
    public lineChartLabels = [];
    public lineChartLegend = true;
    public lineChartType = 'line';
    public lineChartPlugins = [];
    //  public lineChartColors: Color[] = [ { borderColor: '#0FB36C' } ];
    public lineChartOptions: (ChartOptions & { annotation: any }) = {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: true },
        scales: {
            yAxes: [
                {
                    ticks: {
                        maxTicksLimit: 8
                    }
                }
            ],
            xAxes: [
                {
                    type: 'time',
                    distribution: 'series',
                    time: {
                        tooltipFormat: 'DD MMM',
                        displayFormats: {
                            'millisecond': '',
                            'second': 'DD MMM',
                            'minute': 'DD MMM',
                            'hour': 'DD MMM',
                            'day': 'DD MMM',
                            'week': 'DD MMM',
                            'month': 'DD MMM',
                            'quarter': 'DD MMM',
                            'year': 'DD MMM',
                        }
                    }
                },
            ]
        },
        annotation: {},
    };

    public selected: any = {};
    alwaysShowCalendars: boolean;
    showRangeLabelOnInput: boolean;
    keepCalendarOpeningWithRange: boolean;
    ranges: any = {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Last 3 Month': [moment().subtract(3, 'month'), moment()]
    };

    header_data: any = { heading: "PDF Report" };

    constructor(private router: Router, private service: DashboardService, private login: LoginService, private route: ActivatedRoute, private spinner: NgxSpinnerService, public fb: FormBuilder, @Inject(DOCUMENT) private document: Document) {
        this.session_data.id = login.get_session_data('ieye_session_id');
        this.session_data.role = login.get_session_data('ieye_session_role');
        this.service.setTitle('PDF Report | 24ieye');
        this.project_id = this.route.snapshot.queryParams["id"];
        this.alwaysShowCalendars = true;
        this.keepCalendarOpeningWithRange = true;
        this.selected = { startDate: login.get_session_data('ieye_session_start_date'), endDate: login.get_session_data('ieye_session_end_date') };
        this.data_range = this.selected.startDate + ' - ' + this.selected.endDate;
        this.form = this.fb.group({
            summary: [true],
            mentions_by_category: [true],
            latest_mentions: [true],
            influential_sites: [true],
            top_profiles: [true],
            quotes: [true],
            mentions_graph: [true],
            numerical_summary: [true],
            popular_mentions: [true],
            active_profiles: [true],
            active_sites: [true],
            hashtags: [true],
        });
    }

    ngOnInit(): void {
        var formData: any = new FormData();
        formData.append("id", this.project_id);
        //      this.get_project_data(formData);
        formData.append("user_id", this.session_data.id);
        formData.append("start_date", this.selected.startDate);
        formData.append("end_date", this.selected.endDate);
        formData.append("per_page", 5);
        formData.append("project_id", this.project_id);
        this.get_mentions_graph(formData);
    }

    public async get_mentions_graph(formData) {
        this.spinner.show();
        formData.append("type", 'mentions_map');
        formData.append("sentiment_data", true);
        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            this.spinner.hide();
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.lineChartData = [
                { data: this.result.data, label: 'Mentions', borderWidth: 2, pointRadius: 2, lineTension: 0, backgroundColor: 'rgba(0, 0, 0, 0)', stacked: false, borderColor: '#0077CC', pointBorderColor: '#0077CC', pointBackgroundColor: '#0077CC' },
                { data: this.result.positive_data, label: 'Positive Mentions', borderWidth: 2, pointRadius: 2, lineTension: 1, backgroundColor: 'rgba(0, 0, 0, 0)', stacked: false, borderColor: '#45D52B', pointBorderColor: '#45D52B', pointBackgroundColor: '#45D52B' },
                { data: this.result.negative_data, label: 'Negative Mentions', borderWidth: 2, pointRadius: 2, lineTension: 1, backgroundColor: 'rgba(0, 0, 0, 0)', stacked: false, borderColor: '#FF0000', pointBorderColor: '#FF0000', pointBackgroundColor: '#FF0000' },
            ];
            this.response.graph = true;
            this.spinner.hide();
        }
    }

    public async generate_report(form_data) {
        var formData: any = new FormData();
        formData.append("id", this.project_id);
        //      this.get_project_data(formData);
        formData.append("user_id", this.session_data.id);
        formData.append("start_date", this.selected.startDate);
        formData.append("end_date", this.selected.endDate);
        formData.append("per_page", 5);
        formData.append("project_id", this.project_id);
        formData.append("options", JSON.stringify(form_data));
        //this.spinner.show();
        Swal.fire({
            title: 'Generating PDF Report...', html: '<div>We are generating your PDF report and it maybe take more time with huge results.</div> <div>Your report will download automatically.</div><div><img src="assets/images/spinner.gif"></div>',
            showConfirmButton: false, showLoaderOnConfirm: true,
            showClass: { icon: 'swal2-icon-hide' },
            allowOutsideClick: false
        });
        setTimeout(() => {
            this.generate_file(formData);
        }, 3000);

    }

    public async generate_file(formData) {
        html2canvas(document.getElementById('linechart'), { scrollX: -window.scrollX, scrollY: -window.scrollY }).then(canvas => {
            var imgData = canvas.toDataURL();  //console.log(imgData); return false;
            this.canvas_chart = imgData;
            formData.append("chart", imgData);
            this.send_pdf_req(formData);
        });
    }

    public async send_pdf_req(formData) {
        try {
            this.result = await this.service.form_actions(formData, 'pdf_report');
            if (this.result.status == false) {
                Swal.close();
                Swal.fire('Alert!', this.result.message, 'error');
            } else if (this.result.status == true) {
                var download_link = this.result.url;
                Swal.fire({ icon: 'success', title: this.result.message, confirmButtonText: "Download" }).then(function() {
                    window.location.href = download_link;
                });
            } else {
                Swal.close();
                Swal.fire('Alert!', 'Something went wrong! Please try again later.', 'error');
            }
        } catch (err) {
            Swal.close();
            Swal.fire('Alert!', 'Something went wrong! Please try again later.', 'error');
        }

    }

    public async get_project_data(formData) {
        this.result = await this.service.form_actions(formData, 'get_project');
        if (this.result == 'error') {
            Swal.fire('Projects', 'Something went wrong! Please try again later.', 'error');
            return false;
        }
        if (this.result.error == false) {

        } else {
            this.project = this.result.data.name;
            this.response.project = true;
            //this.download_as_pdf();
        }
    }

    datesUpdated(range) {
        if (range.startDate != null && range.endDate != null) {
            this.service.saveDateRange(moment(range.startDate._d).format("YYYY-MM-DD"), moment(range.endDate._d).format("YYYY-MM-DD"));
            this.selected = { startDate: this.login.get_session_data('ieye_session_start_date'), endDate: this.login.get_session_data('ieye_session_end_date') };
            this.data_range = this.selected.startDate + ' - ' + this.selected.endDate;

            var formData: any = new FormData();
            formData.append("id", this.project_id);
            //      this.get_project_data(formData);
            formData.append("user_id", this.session_data.id);
            formData.append("start_date", this.selected.startDate);
            formData.append("end_date", this.selected.endDate);
            formData.append("per_page", 5);
            formData.append("project_id", this.project_id);
            this.get_mentions_graph(formData);
        }
    }

    pdfCallbackFn(pdf: any) {
        // example to add page number as footer to every page of pdf
        const noOfPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= noOfPages; i++) {
            pdf.setPage(i);
            pdf.text('Page ' + i + ' of ' + noOfPages, pdf.internal.pageSize.getWidth() - 100, pdf.internal.pageSize.getHeight() - 30);
        }
    }

    public change_date_format(date, format) {
        return moment.tz(date, 'Asia/Muscat').format(format);
    }

    public get_social_icon(channel) {
        switch (channel) {
            case 'web': {
                return 'assets/images/icons/share-2.png';
                break;
            }
            case 'facebook': {
                return 'assets/images/icons/facebook.png';
                break;
            }
            case 'instagram': {
                return 'assets/images/icons/instagram.png';
                break;
            }
            case 'twitter': {
                return 'assets/images/icons/twitter.png';
                break;
            }
            case 'youtube': {
                return 'assets/images/icons/youtube.png';
                break;
            }
            case 'linkedin': {
                return 'assets/images/icons/linkedin.png';
                break;
            }
            default: {
                return 'assets/images/icons/share-2.png';
                break;
            }
        }
    }

}
